<template>
  <div v-hotkey="disableKeymap ? {} : keymap"
       class="options-list-box-container"
       ref="optionsList"
       :class="{
        'list-box-container-margin': optionsBoxStyles.showPaneMargin,
        'internal-nakdan' : internalNakdan,
        frame: optionsBoxStyles.showPaneMargin, // note that the border RADIUS is overridden below
        'list-box-container-mobile': optionsBoxStyles.Mobile,
        'small-min-height': optionsBoxStyles.smallMinHeight,
        'reg-min-height': !(optionsBoxStyles.smallMinHeight)
    }">
    <b-container style="height: 100%; padding: 0">
      <b-row v-show="optionsToShow.length"
            class="options-list-container row"
            :class="{'text-center': optionsBoxStyles.Mobile, 'text-right': optionsBoxStyles.Desktop}"
            no-gutters>
        <b-col v-for="col in columnIndices" :key="'option-list-column-'+col" :cols="12/columns" class="option-col">
          <div v-for="(option, o) in optionsToShow"
            v-bind:id="'option-row-' + o"
            @click="optionClicked(o, $event)"
            @dblclick="optionClicked(o, $event)"
            @mouseover="hoveredOption = o" @mouseout="hoveredOption = -1"
            class="option-row clickable-option-row"
            v-bind:class="{
              'row-mobile': optionsBoxStyles.Mobile,
              'mb-0': showExtended,
              'pt-3': showExtended,
              'pb-3': showExtended,
              'highlighted-row': (workingOption === o) && matchesChosen(option),
              'framed-row': (workingOption === o) && !(matchesChosen(option)),
              'hovered-option': o === hoveredOption,
              'from-user-dict-negatives': optionsBoxStyles.implementUserAccounts && option.fromUserDictionaryNegatives }"
            :key="o">
            <div v-if="optionsBoxStyles.implementUserAccounts" style="float:left">
              <span
                v-show="(o === hoveredOption) && !(option.fromUserDictionary) && !(option.fromUserDictionaryNegatives)"
                class="click-only-here"
                @click.stop="moveOptionToEnd({ whichEnd: 'bottom', shownOption: o })">
                <span class="dictionary-button"><i class="fa fa-sort-amount-down"></i></span>
              </span>
              <span
                v-show="(o === hoveredOption) &&
                              (!(option.fromUserDictionary)
                                || pinnedOptionsFromUserDictionary.indexOf(option) > 0
                                || unpinnedOptionsFromUserDictionary.indexOf(option) > 0)"
                class="click-only-here"
                v-bind:title="option.fromUserDictionary ? 'העלה יותר למעלה ברשימה' : ''"
                @click.stop="moveOptionToEnd({ whichEnd: 'top', shownOption: o })">
                <span class="dictionary-button" v-show="option.fromUserDictionary"><i-arrow-up></i-arrow-up></span>
                <span class="dictionary-button" v-show="!(option.fromUserDictionary) && !(option.fromUserDictionaryNegatives)">
                  <i-star></i-star>
                </span>
              </span>
              <span
                v-show="optionsBoxStyles.offerPinning && (o === hoveredOption) && option.fromUserDictionary && !(option.pinned)"
                class="click-only-here"
                title="הצמד לראש הרשימה"
                @click.stop="togglePinned(o)">
                <span class="dictionary-button"><i class="far fa-hand-point-up"></i></span>
              </span>
              <span v-show="option.fromUserDictionary && option.pinned" class="dictionary-button"
                @click.stop="togglePinned(o)"><i class="fas fa-hand-point-up"></i></span>
              <span v-show="option.fromUserDictionary" class="dictionary-button"
                @click.stop="$emit('remove-from-user-dictionary', option); initWorkingOption()"><i-star :solid="true"></i-star></span>
              <span v-show="o === hoveredOption && option.fromUserDictionaryNegatives" class="dictionary-button"
                @click.stop="$emit('remove-from-user-dictionary-negatives', option); initWorkingOption()"><i class="fa fa-sort-amount-up-alt"></i></span>
            </div>
            <p><span class="option-letter" v-html="optionKey(o)"></span><span :style="'color:' + optionsBoxStyles.prefixColor" v-html="getPrefixHTML(option, col)"></span><span v-html="getAfterPrefixHTML(option, col)"></span><span v-if="option.conditions && option.conditions.length" style="color:pink"> {{ afterWordConditionString(option.conditions) }}</span>
            <span v-if="option.comment" class="option-comment"> {{ option.comment }}</span>
            <small @click.stop="$emit('occurence-num-clicked', option)" v-if="showOccurrences"
              :class="{'text-muted' :option.occurrences && option.occurrences.number == 0 || !option.occurrences}"
              class="text-primary occurrence-count mx-3">{{option.occurrences ? option.occurrences.number : '0'}}
            </small>
            </p>
            <div v-if="showExtended" class="morph">
              <p class="mb-0" v-for="(morphLine, mli) in prettyPrintedMorphArray(option.morphArray)" :key="mli" v-html="morphLine"></p>
            </div>
          </div>
        </b-col>
      </b-row>
      <div class="options-account-needed-popup click-only-here" v-show="showAccountNeededPopup">
        text will be filled in dynamically
      </div>
    </b-container>
  </div>
</template>

<script>
import optionsListKeyMap from './optionsListKeyMap'
import {prettyPrintedMorphArray} from 'shared/js/morphologies' // getAllMorphStrings() is in KeyMap code commented at this time
import $ from 'jquery'
import scrollParentToChild from 'shared/js/scrollParentToChild'
import conditionalOptions from 'shared/js/conditionalOptions'
import styleGlobals from 'shared/js/forTextPanel/styleGlobals'

const optionsPaneLetterKeyOrder = 'FSJLREIOVCXM' // duplicated in NikudOptionsPaneKeyMap
const optionsPaneNumberKeyOrder = '0123456789' // duplicated in NikudOptionsPaneKeyMap
// const KEEP_PUNCTUATION = true

function displayWithOrWithoutAims (text, aimCondition, lineBreakCondition = false) {
  return text.replace(/\n/g, lineBreakCondition ? '↳' : '\n').replace(/(.)ֽ/g, aimCondition ? '<span style="color: ' + styleGlobals.hideableColor + '">' + '$1' + '</span>' : '')
}

export default {
  name: 'OptionsList',
  mixins: [optionsListKeyMap],
  props: {
    internalNakdan: { default: false },
    showOccurrences: {default: false},
    paneOpen: { default: true },
    columns: { default: 1 },
    columnSeparator: { default: 'COLUMN_SEPARATOR' },
    autoInitObj: { default: () => { return { command: null } } },
    optionsBoxStyles: {
      default: () => {
        return {
          Mobile: window.innerWidth < 992,
          Desktop: window.innerWidth >= 992,
          prefixColor: 'red',
          showPaneMargin: false,
          smallMinHeight: false,
          implementUserAccounts: false,
          offerPinning: false,
          nikudKeyboard: 'new',
          // (only needed for hotkey which now is run from PANE) offerGenderChanging: false,
          xNegatesInBlind: false
        }
      }
    },
    showExtended: { default: false },
    localShowAims: { default: true },
    allowOptionKeys: { default: true },
    optionsToShow: {},
    relevantOptionsFromUserDictionary: { default: () => { return [] } },
    pinnedOptionsFromUserDictionary: { default: () => { return [] } },
    unpinnedOptionsFromUserDictionary: { default: () => { return [] } },
    relevantNegativeOptionsFromUserDictionary: { default: () => { return [] } },
    localCurrentWordIndex: {}, // for having watch on changing word
    optionMatcherProperty: {}, // which property of the option to match
    optionMatcherValue: {}, // value of that property for the word's "chosen" option
    optionMatcherBackup: { default: '' },
    optionMatcherChoiceType: {}, // some nakdan-related features depend on the current word's choiceType
    spaceSubstitute: { default: null },
    disableKeymap: { default: false }
  },
  data () {
    return {
      workingOption: -1,
      hoveredOption: -1,
      showAccountNeededPopup: false
    }
  },
  computed: {
    hebrew () {
      return (!(this.$settings)) || this.$settings.hebrew // default should be Hebrew here
    },
    columnIndices () {
      return [...Array(this.columns)].map((_, i) => i)
    },
    conditionalDictStringsMatchingCurrentWord () {
      const workingOptionObj = this.optionsToShow[this.workingOption]
      return (workingOptionObj[this.optionMatcherProperty] === this.optionMatcherValue
              && workingOptionObj.conditions && workingOptionObj.conditions.length)
                  ? [conditionalOptions.dictStringFromOptionObj(workingOptionObj)] : []
    },
    optionsToShowStr () {
      return JSON.stringify(this.optionsToShow.map(
        o => [o.displayText].concat(o.conditions ? o.conditions.map(c => c.value) : []).join(' ')))
    },
    autoInitCommand () {
      return this.autoInitObj.command
    },
    matcherValueWithOrWithoutAims () {
      return displayWithOrWithoutAims(this.optionMatcherValue, this.localShowAims)
    }
  },
  watch: {
    workingOption (newWorkingOption) {
      this.$emit('working-option-set', newWorkingOption)
    },
    autoInitCommand (newAutoInitCommand) { // for undo/redo that's ONLY visible in the options list
      if (newAutoInitCommand) {
        this.initWorkingOption()
        this.autoInitObj.command = false
      }
    },
    localCurrentWordIndex: function (newLocalCurrentWordIndex) {
      if (newLocalCurrentWordIndex !== -1) this.initWorkingOption()
    },
    optionsToShowStr: function () { // for change from outside the pane [e.g. dictionaryEntryFromRange()]
      this.initWorkingOption()
    },
    optionMatcherValue () {
      this.initWorkingOption()
    }
  },
  methods: {
    afterWordConditionString (conditionsArray) {
      return conditionalOptions.afterWordConditionString(conditionsArray)
    },
    prettyPrintedMorphArray (morphArray) { // for the render to access it, it needs to be in "this"
      return prettyPrintedMorphArray(morphArray) // (b/c "morphMethods" is no longer a mixin)
    },
    matchesChosen (option) {
      return option[this.optionMatcherProperty] === this.optionMatcherValue
    },
    optionKey (optionIndex) {
      return (optionIndex <
        ((this.optionsBoxStyles.nikudKeyboard === 'old') ? optionsPaneLetterKeyOrder : optionsPaneNumberKeyOrder).length)
          ? ((this.optionsBoxStyles.nikudKeyboard === 'old') ? optionsPaneLetterKeyOrder : optionsPaneNumberKeyOrder)
            .charAt(optionIndex) : '&nbsp;'
    },
    getOptionSegmentHTML (o, optionSegmentText) {
      return displayWithOrWithoutAims((
              this.localShowAims && o.displayVariants && o.displayVariants.ifShowingAimsRegExpArgs
                ? optionSegmentText.replace(new RegExp(...(o.displayVariants.ifShowingAimsRegExpArgs)),
                                            o.displayVariants.ifShowingAimsReplacement)
                : optionSegmentText), this.localShowAims)
    },
    getPrefixHTML (o, col) {
      let textToSplit = o.displayText
      if (this.spaceSubstitute) textToSplit = textToSplit.replace(new RegExp(this.spaceSubstitute, 'g'), ' ')
      const prefixText = (o.prefixEndIndex === -1 || col > 0) ? ''
                                        : textToSplit.split(/(?=[^ְֱֲֳִֵֶַָׇֹֻּׁׂ])/).slice(0, o.prefixEndIndex).join('')
      return this.getOptionSegmentHTML(o, prefixText)
    },
    getAfterPrefixHTML (o, col) {
      let textToSplit = o.displayText
      if (this.spaceSubstitute) textToSplit = textToSplit.replace(new RegExp(this.spaceSubstitute, 'g'), ' ')
      const afterPrefixText = textToSplit.split(this.columnSeparator)[col].split(/(?=[^ְֱֲֳִֵֶַָׇֹֻּׁׂ])/).slice(Math.max(0, o.prefixEndIndex)).join('')
      return this.getOptionSegmentHTML(o, afterPrefixText)
    },
    optionClicked (o) {
      this.workingOption = o
      if (this.optionsBoxStyles.Desktop && !(this.optionsToShow[o].fromUserDictionaryNegatives)) {
        this.useNewChoice()
        this.moveToNextWord()
      }
    },
    initWorkingOption () {
      var optionDisplays = this.optionsToShow.map(o => displayWithOrWithoutAims(o[this.optionMatcherProperty], this.localShowAims))
      this.workingOption = optionDisplays.includes(this.matcherValueWithOrWithoutAims)
        ? optionDisplays.indexOf(this.matcherValueWithOrWithoutAims)
        : optionDisplays.indexOf(displayWithOrWithoutAims(this.optionMatcherBackup))
      setTimeout(() => {
        if (this.paneOpen) this.scrollOptionsList()
      }, 1)
    },
    moveToNextOption () {
      if (this.workingOption < this.optionsToShow.length - 1) {
        this.workingOption += 1
        if (!(this.optionsToShow[this.workingOption].fromUserDictionaryNegatives)) {
          this.useNewChoice()
        }
        if (this.paneOpen) this.scrollOptionsList()
      }
    },
    moveToPreviousOption () {
      if (this.workingOption > 0) {
        this.workingOption -= 1
        if (!(this.optionsToShow[this.workingOption].fromUserDictionaryNegatives)) {
          this.useNewChoice()
        }
        if (this.paneOpen) this.scrollOptionsList()
      }
    },
    moveToFirstOption () {
      this.workingOption = 0
      this.useNewChoice()
      if (this.paneOpen) this.scrollOptionsList()
    },
    moveToLastOption () {
      this.workingOption = this.optionsToShow.length > this.relevantNegativeOptionsFromUserDictionary.length
        ? this.optionsToShow.length - this.relevantNegativeOptionsFromUserDictionary.length - 1 : 0
      this.useNewChoice()
      if (this.paneOpen) this.scrollOptionsList()
    },
    changeWorkingOption (newOption) {
      if (newOption < this.optionsToShow.length) {
        this.workingOption = newOption
        this.useNewChoice()
        this.moveToNextWord()
      }
    },
    useNewChoice () {
      this.$emit('use-new-choice', this.workingOption)
    },
    moveToNextWord () {
      this.$emit('move-to-next-word')
    },
    scrollOptionsList () {
      if (this.$refs.optionsList.contains(document.activeElement))
        document.activeElement.blur()
      const listWindow = document.getElementsByClassName('options-list-container')[0].children[0]
      // console.log('this.workingOption:')
      // console.log(this.workingOption)
      if (listWindow && this.workingOption !== -1 && this.workingOption < listWindow.children.length) {
        setTimeout(() => {
          scrollParentToChild(listWindow.parentElement.parentElement.parentElement, listWindow.children.item(this.workingOption))
        }, 1)
      }
    },
    // methods below here are not used by the 'Simple' Nakdan
    showAccountNeeded (o, directionAttempted) {
      const popupElement = $('.options-account-needed-popup')
      popupElement.css('bottom', 'unset')
      popupElement.css('top', $('#option-row-' + o).position().top + $('.options-list-box-container').position().top
        - (25 * 2 + 8 * 2) + 'px') // the popup's line-height is 25 and its padding is 8
      const popupText = directionAttempted === 'top'
                          ? (this.hebrew
                              ? 'כדי להוסיף מילה למאגר, יש להתחבר לחשבון האישי.'
                              : 'To add an option to your personal list, please log in to your account.')
                          : (this.hebrew
                              ? 'כדי לסמן מילה כלא רלוונטית, יש להתחבר לחשבון האישי.'
                              : 'In order to set an option as invalid, please log in to your account.')
      popupElement.text(popupText)
      this.showAccountNeededPopup = true
    },
    togglePinned (o) {
      const newValueOfWhetherPinned = !(this.optionsToShow[o].pinned)
      const optionDisplayText = this.optionsToShow[o].displayText
      this.$emit('toggle-pinned', o)
      setTimeout(() => {
        if (newValueOfWhetherPinned) {
          this.workingOption = this.optionsToShow.map(o => o.displayText).indexOf(optionDisplayText)
          this.useNewChoice()
          if (this.paneOpen) this.scrollOptionsList()
        } else this.initWorkingOption()
      }, 2)
    },
    moveOptionToEnd (moveToEndObj) {
      if (!(this.$store.state.account && this.$store.state.account.isLoggedIn)) {
        this.showAccountNeeded(moveToEndObj.shownOption, moveToEndObj.whichEnd)
        return
      }
      const optionDisplayText = this.optionsToShow[moveToEndObj.shownOption].displayText
      this.$emit('move-option-to-end', moveToEndObj)
      setTimeout(() => {
        if (moveToEndObj.whichEnd === 'top') {
          this.workingOption = this.optionsToShow.map(o => o.displayText).indexOf(optionDisplayText)
          this.useNewChoice()
          if (this.paneOpen) this.scrollOptionsList()
        } else this.initWorkingOption()
      }, 2)
    }
  },
  mounted: function () {
    $(document).on('click', '.click-only-here', function (e) {
      e.stopPropagation() // note: only works on elements which exist at this time! (not dict buttons)
    })
    $(document).on('click', () => {
      this.showAccountNeededPopup = false
    })
    if (this.localCurrentWordIndex > -1) {
      this.initWorkingOption()
    }
  }
}
</script>

<style scoped lang="scss">
.options-list-box-container {
  flex: auto;
  overflow: auto;
  font-family: Roboto, mft_narkisclassic, sans-serif;
  font-size: 20px;
  line-height: 25px;
  padding: 0;
}
.options-list-box-container.frame {
  border-radius: 4px;
}
.option-row:first-child {
  margin-top: 4px;
}
.option-row:last-child {
  margin-bottom: 4px;
}
.options-list-container {
  height: 100%;
  width: 100%;
}
body.he .option-col:not(:first-child), body:not(.he) .option-col:not(:last-child) {
  border-right: 1px solid var(--secondary);
}
.list-box-container-mobile {
  font-size: 28px !important;
  line-height: 40px !important;
  text-align: center !important;
  padding-top: 12px !important;
  padding-bottom: 70px !important;
  flex: none !important;
  height: 50vh !important;
}
.list-box-container-margin {
  margin: 0 14px 10px;
  &.internal-nakdan {
    margin: 0 7px 2px;
  }
}
.reg-min-height {
  height: 30vh; /* allow shrinking to less than content size */
}
.small-min-height {
  height: 62px; /* two rows */
}
.option-letter {
  font-family: Roboto;
  color: #8D8D8D;
  font-size: 13px;
  padding-left: 10px;
  display: none;
}
.options-list-box-container p {
  margin-bottom: 0;
}
.option-row {
  padding: 0 10px 0 6px;
  margin-bottom: 2px;
}
.option-comment {
  font-family: Arimo;
  font-size: 14px;
  color: #8D8D8D;
}
.occurrence-count {
  font-family: 'Arimo';
  &:not(.text-muted) {
    &:hover {
      text-decoration: underline;
    }
  }
  &.text-muted {
    cursor: default;
  }
}
.row-mobile {
  margin-right: 15px;
  margin-left: 15px;
  border-radius: 6px;
}
.clickable-option-row, .dictionary-button {
  cursor: pointer;
}
.hovered-option {
  background-color: #f6f6f6;
}
.from-user-dict-negatives {
  color: #c0c0c0;
}
.options-list-box-container{
  .row-mobile{
    margin-right: 25px;
    margin-left: 21px;
    border-style: solid;
    border-color: transparent;
    &.highlighted-row {
      border-radius: 6px;
    }
    &.hovered-option {
       background-color: #d6ecff;
    }
  }
}
.highlighted-row {
  background-color: #d6ecff !important;
}
.framed-row {
  border-style: solid;
  border-color: #d6ecff;
}
.morph {
  font-size: 16px;
  @media screen and (max-width: 767px) {
    font-family: mft_narkisclassic;
    font-size: 18px;
    p {
      line-height: 30px;
    }
  }
}
</style>
